import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';

export default function TopBar() {
  return (
    <div className="w-full bg-[#0d3a8a] text-slate-200 text-sm">
      <div className="container-x flex items-center justify-center gap-8 py-2">
        <a href="#" className="inline-flex items-center gap-2 hover:text-white transition-colors">
          <Facebook size={14} /> Facebook
        </a>
        <span className="opacity-40">|</span>
        <a href="#" className="inline-flex items-center gap-2 hover:text-white transition-colors">
          <Instagram size={14} /> Instagram
        </a>
        <span className="opacity-40">|</span>
        <a href="#" className="inline-flex items-center gap-2 hover:text-white transition-colors">
          <Twitter size={14} /> Twitter
        </a>
      </div>
    </div>
  );
}
